import { render, staticRenderFns } from "./AppSvgIcon.vue?vue&type=template&id=3e9af12c&scoped=true&"
import script from "./AppSvgIcon.vue?vue&type=script&lang=js&"
export * from "./AppSvgIcon.vue?vue&type=script&lang=js&"
import style0 from "./AppSvgIcon.vue?vue&type=style&index=0&id=3e9af12c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e9af12c",
  null
  
)

export default component.exports